import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    ForwarderCategory,
} from 'app/enums/label.enums'

import {
    FreightForwarderFilterRequestResponse,
} from './FreightForwarders.types'

const config: SkyNetTableConfig<keyof FreightForwarderFilterRequestResponse> = {
    name: 'Damages',
    tabs: [{
        name: 'All',
        url: 'all',
        fields: [
            {
                name: 'freightForwarderName',
                filterField: 'freightForwarderName',
                labelKey: 'FreightForwarders.name',
                reduced: true,
            },
            {
                name: 'companyName',
                filterField: 'companyName',
                labelKey: 'FreightForwarders.company',
                reduced: true,
            },
            {
                name: 'forwarderCategory',
                filterField: 'forwarderCategory',
                filterType: FilterType.Array,
                componentName: 'EnumList',
                allowedValuesEnum: ForwarderCategory,
                labelKey: 'FreightForwarders.forwarderCategory',
            },
            {
                name: 'createdOn',
                labelKey: 'FreightForwarders.createdOn',
            },
            {
                name: 'createdBy',
                labelKey: 'FreightForwarders.createdBy',
            },
        ],
    }],
}

export default config
